<template>
    <div>
        <div v-if="carts.length">
            <cart-item
                v-for="cart in carts"
                :key="cart.id"
                :corporation="corporation"
                :cart="cart"
                :permissions="permissions"
            />
        </div>
        <div v-else>
            <div class="placeholder">
                <p>{{ $l10n.__('Aucun panier pour ce compte') }}</p>
            </div>
        </div>
    </div>
</template>
<script>
import CartItem from './CartItem.vue';
import WidgetMixins from '../../mixins/sellsyaccountmanager/widgetMixins.js';

export default {
    components: { CartItem },
    mixins: [WidgetMixins],
    props: {
        corporation: {
            type: String,
            required: true,
        },
        carts: {
            type: Array,
            required: true,
        },
        products: {
            type: Array,
            required: true,
        },
        permissions: {
            type: Object,
        },
    },
    created() {
        this.setPricingProducts(this.products);
    },
};
</script>

<style lang="scss" scoped>
@use '~@sellsy/styleguide/src/_variables' as *;
.well + .well {
    margin-top: $val-3;
}
</style>
